import { Button } from 'components/ui/Button'
import useLocaleText from 'components/useLocaleText'
import React, { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useSkipSubtask } from '../TasksOverview/hooks/useSkipSubtask'
import { SkipReasonsModal } from './SkipReasonsModal'
import { RootState } from 'constants/interfaces'
import { getReasonsByRetailer } from 'components/TasksV2/UI/ReasonComponents/reasonsConfig'

interface IProps {
  isRequired: boolean
  isSkipped: boolean
  isResult: boolean
  subtaskType: number
  tid: string
  st_id: string
  resultContextId: string
}
export const SkipSubtaskButton: React.FC<IProps> = memo(
  ({ isRequired, isSkipped, isResult, subtaskType, tid, st_id, resultContextId }) => {
    const skip = useSkipSubtask({
      tid,
      st_id,
      subtaskType,
      resultContextId,
      unavailable: isRequired || isResult || isSkipped,
    })
    const t_subtask_skip = useLocaleText('skip_st')
    const t_skipped = useLocaleText('skipped')

    // Get retailer ID from config
    const rid = useSelector((state: RootState) => state.config.config?.rid)

    // Get skip reasons for the current retailer
    const skipReasons = useMemo(() => getReasonsByRetailer(rid, 'skip'), [rid])

    const buttonText = isSkipped ? t_skipped : t_subtask_skip

    if (isResult || isRequired || skip.isReadMode) {
      return null
    }
    return (
      <>
        <Button
          type="button"
          variant="secondary"
          borderRadius="8px"
          w="max-content"
          fontSize="12px"
          color="#EA9999"
          h="30px"
          border={isSkipped ? 'none' : '1px solid #EA9999'}
          pointerEvents={isSkipped ? 'none' : 'auto'}
          isDisabled={skip.disabled}
          onClick={skip.open}
          _hover={{ bg: '#fff8fb' }}
        >
          {buttonText}
        </Button>

        <SkipReasonsModal
          isOpen={skip.isModalOpen}
          onClose={skip.close}
          onConfirm={skip.confirm}
          isSubmitting={skip.isSubmitting}
          hasError={skip.hasError}
          predefinedReasons={skipReasons}
        />
      </>
    )
  }
)
